import { render, staticRenderFns } from "./ModalReestructuraRenovacion.vue?vue&type=template&id=1d0a9dfa&"
import script from "./ModalReestructuraRenovacion.vue?vue&type=script&lang=js&"
export * from "./ModalReestructuraRenovacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports